import React from "react";

function Skill() {
  return (
    <div id="skill" className="text-center abt-container" style={{paddingTop: "30px"}}>
      <h1 className="project-heading">
        <button>Skills</button>
      </h1>
      <div>
          <div style={{display: 'flex', justifyContent:"space-around", paddingTop:"20px" }}>
              <div>
          <h3>Frontend</h3>
          <hr></hr>
          <div>
            <p>HTML, CSS, JavaScript </p>
            <p>React.js(lifecycle & hooks)/Next.js </p>
            <p>Bootstrap/MaterialUI</p>
            <p>
              Rest API (Fetch/axios), Fontawesome(icons)
            </p>
            <p>
              Storybook, Atomic
              design project model
            </p>
          </div>
        </div>
        <div>
          <h3>Backend</h3>
          <hr></hr>
          <div>
            <p>Node.js, NPM, Express</p>
            <p>MongoDB</p>
            <p>Postman</p>
          </div>
        </div><div>
          <h3>Application Deployment and other</h3>
          <hr></hr>
          <div>
            <p>Netlify/Heroku</p>
            <p>Github</p>
            <p>CI/CD</p>
            <p>JIRA/VSTS</p>
            <p>Agile-Scrum, SDLC</p>
          </div>
        </div>
      </div>
          </div>
        
        
      <br />
      <br />
      <br />
    </div>
  );
}

export default Skill;
